import { render, staticRenderFns } from "./ChemUCI1LC_Q4S2_Q8.vue?vue&type=template&id=0b9ef1f7&"
import script from "./ChemUCI1LC_Q4S2_Q8.vue?vue&type=script&lang=js&"
export * from "./ChemUCI1LC_Q4S2_Q8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCheckbox,VForm})
